import React from "react";

import {
    Card,
    CardTitle,
    CardContent,
    KeyValueList,
    Spinner,
    Text,
    ConfirmActionButton
} from "@tv2no/ui-react";

export const DataSources = ({ busy, taxYear, dataStatus, deleteTaxData }) => {
    const { searchIndexRecords, numberOfListFiles, listIndexExists } = dataStatus || {};
    return (
        <Card>
            <CardTitle title="Datastatus" />
            <CardContent>
                {dataStatus ? (
                    <KeyValueList align="left">
                        <KeyValueList.Item label="Søkeindeks">
                            {searchIndexRecords !== null ? (
                                `${searchIndexRecords} rader`
                            ) : (
                                <Text color="error">Mangler</Text>
                            )}
                        </KeyValueList.Item>
                        <KeyValueList.Item label="Listefiler">
                            <Text color={numberOfListFiles < 1 ? "error" : null}>
                                {numberOfListFiles} filer
                            </Text>
                        </KeyValueList.Item>
                        <KeyValueList.Item label="Listeindeks">
                            {listIndexExists ? (
                                <Text color="success">Opprettet</Text>
                            ) : (
                                <Text color="error">Mangler</Text>
                            )}
                        </KeyValueList.Item>
                        <KeyValueList.Item label="Fødselsår (fra-til)">
                            <Text color={!taxYear.birthYearFrom ? "error" : null}>
                                {taxYear.birthYearFrom
                                    ? `${taxYear.birthYearFrom} - ${taxYear.birthYearTo}`
                                    : "Ikke satt"}
                            </Text>
                        </KeyValueList.Item>
                    </KeyValueList>
                ) : (
                    <Spinner />
                )}
            </CardContent>
            {!busy && (searchIndexRecords > 0 || numberOfListFiles > 0 || listIndexExists) ? (
                <CardContent border="top">
                    <ConfirmActionButton
                        popup
                        fill={false}
                        size="small"
                        label="Slett skattedata"
                        question={`Er du sikker på at du vil slette all data for skatteåret ${taxYear?.year}? Dette inkluderer søkeindex, aggregerte lister og listeindeksen.`}
                        onConfirm={deleteTaxData}
                    />
                </CardContent>
            ) : null}
        </Card>
    );
};
